import { format } from 'date-fns';
import type { DateRange } from 'react-day-picker';

export function DataTableDateRangeLabel({ range }: { range: DateRange | undefined }) {
  if (!range?.from && !range?.to) return null;
  if (range.from && range.to) {
    return (
      <>
        {format(range.from, 'MMM d')} – {format(range.to, 'MMM d, yyyy')}
      </>
    );
  }
  if (range.from) return <>From {format(range.from, 'MMM d, yyyy')}</>;
  return <>Until {format(range.to!, 'MMM d, yyyy')}</>;
}
